/**
 * HelpButton Component
 * ? icon next to page titles. Opens HelpDrawer.
 */

import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { HelpDrawer } from '../HelpDrawer';

interface HelpButtonProps {
  pageKey: string;
}

export function HelpButton({ pageKey }: HelpButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center justify-center rounded-full text-muted-foreground/60 transition-colors hover:text-foreground hover:bg-muted/50"
        style={{ width: 28, height: 28 }}
        title="Ayuda"
      >
        <HelpCircle size={18} />
      </button>
      <HelpDrawer pageKey={pageKey} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
